import type QuoteDetails from '@/services/models/QuoteDetails'
import type SchemeQuoteResult from '@/services/models/SchemeQuoteResult'
import moment from 'moment'
import Utils from './Utils'

export default class TractiveUtils extends Utils {
  coverType<T extends SchemeQuoteResult>(quote: QuoteDetails<T>, selectedSchemeQuoteResult: number): string {
    return quote.results.find(r => r.id === selectedSchemeQuoteResult)!.schemeName
  }

  getRenewalDate<T extends SchemeQuoteResult>(quote: QuoteDetails<T>): Date {
    return moment(quote.effectiveDate)
      .add(1, 'year')
      .hours(23)
      .minutes(59)
      .seconds(59)
      .toDate()
  }

  async handleBrandSwitching() {
    await import(`@/styles/yes/global.scss`)
    await import(`@/styles/yes-dark/global.scss`)
    await import(`@/styles/tractive/global.scss`)

    if (this.useAlternateBranding())
      return this.applyYesBranding()

    else if (this.useAlternateDarkBranding())
      return this.applyYesDarkBranding()

    else
      this.applyTractiveBranding()
  }

  useAlternateBranding(): boolean {
    return window.location.hostname.includes('tractive.yes.')
  }

  useAlternateDarkBranding(): boolean {
    return window.location.hostname.includes('tractive.yes-dark.') || window.location.hostname.startsWith('yes-')
  }

  private applyYesBranding() {
    document.documentElement.classList.add('branding-yes')
    document.documentElement.classList.remove('branding-tractive')
    document.documentElement.classList.remove('branding-dark')
  }

  private applyYesDarkBranding() {
    document.documentElement.classList.add('branding-dark')
    document.documentElement.classList.remove('branding-tractive')
    document.documentElement.classList.remove('branding-yes')
  }

  private applyTractiveBranding() {
    document.documentElement.classList.add('branding-tractive')
    document.documentElement.classList.remove('branding-yes')
    document.documentElement.classList.remove('branding-dark')
  }
}
